import { NgStyle } from '@angular/common';
import { Component, ChangeDetectorRef } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TFMService } from 'app/mock-api/tfm.service';


@Component({
  selector: 'app-non-profit-organizations-type01',
  standalone: true,
  imports: [MatIconModule, NgStyle],
  templateUrl: './non-profit-organizations-type01.component.html',
  styleUrl: './non-profit-organizations-type01.component.scss'
})
export class nonProfitOrganizationsType01Component {

  public view: any = {};

  constructor(private _tfmService: TFMService, private _cd: ChangeDetectorRef) {

    this._tfmService.getContentBySection('non-profit').then(res => {
      this.view.page = res;
      this._tfmService.log(this.view);

      if (this.view.page && this.view.page?.content?.images && this.view.page?.content?.images.length > 0) {
        const image = this.view.page?.content?.images[0]; // Access the first image object
        const links = image._links; // Access the _links array
      
        // Find the link with rel "view"
        const viewLink = links.find((link: any) => link.rel === "view");
      
        // Get the href if the view link exists
        if (viewLink) {
          this.view.imageHref = viewLink.href;
          this._tfmService.log("Image href:", this.view.imageHref);
          this._cd.detectChanges();
        } else {
          console.error("View link not found");
        }
      } else {
        console.error("Images not available");
      }
    });
    
    this._tfmService.getSite().then(res => {
        this.view.site = res;

        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        this._tfmService.log('Non profit check: ', this.view);
      });
  }
}
